<template>
    <span :class="className" :style="colorStyle">
        <mdicon :name="iconName" />
    </span>
</template>

<script>

// TODO: color & size 共通デザインmixin化
const colors = [
    // TODO: colorのルールぎめ
    'normal',
    'success',
    'error',
    'accent',
    'primary',
    'seccondary',
];
// TODO: sizeのルールぎめ
// const sizes = [
//     'normal',
//     'small',
//     'x-small',
//     'large',
//     'x-large',
// ];

export default {
    props: {
        color: {
            type: String,
            default: 'normal',
        },
    },
    computed: {
        iconName: function() {
            return this.$slots.default[0].text.trim()
        },
        className: function() {
            return colors.indexOf(this.color) != -1 ? `pochi_icon__${this.color}` : null;
        },
        colorStyle: function() {
            return colors.indexOf(this.color) != -1  ? null : { color: this.color }
        },
    },

}
</script>

<style lang="sass">
.pochi_icon
    &__normal
        color: $grayColor
    &__success
        color: #02ad90
    &__error
        color: #ff5252
    &__accent
    &__primary
        color: $mainColor
    &__seccondary
</style>
